'use strict';

const px = require('@mindmup/mapjs-core/src/util/px'),
	calculateEmojis = require('@mindmup/mapjs-core/src/util/calculate-emojis'),
	ensureElementIfNeeded = require('./util/ensure-element-if-needed'),
	applyLinkUrl = require('./apply-link-url'),
	applyLabel = require('./apply-label'),
	applyAttachment = function (decorationsElement, attachment, nodeId /*TODO: remove nodeId parameter*/) {
		const element = ensureElementIfNeeded(decorationsElement, 'a', 'a.mapjs-attachment', !!attachment, {class: 'mapjs-attachment icon-attachment', 'decoration-type': 'attachment'});
		if (element) {
			element.dispatchEvent(new CustomEvent('attachment-link-created', {detail: {nodeId: nodeId}, bubbles: true}));
		}
	},
	applyNote = function (decorationsElement, note) {
		return ensureElementIfNeeded(decorationsElement, 'a', 'a.mapjs-note', !!note, {class: 'mapjs-note icon-note', 'decoration-type': 'note'});
	},
	applyStickers = (decorationsElement, stickers, decorationsMetrics) => {
		const emojiText = calculateEmojis(stickers).join(''),
			shouldBeShown = emojiText.length,
			width  = shouldBeShown && px((stickers.length * (decorationsMetrics.standardDecorationWidth + decorationsMetrics.standardDecorationMargin)) - decorationsMetrics.standardDecorationMargin),
			element = ensureElementIfNeeded(decorationsElement, 'a', '.mapjs-stickers', shouldBeShown, {class: 'mapjs-stickers', 'decoration-type': 'stickers'});

		if (shouldBeShown) {
			element.style.minWidth = width;
			element.innerText = emojiText;
		}
	},
	updateDecorations = (nodeView, decorationsDOM) => {
		const nodeMetrics = nodeView.metrics;
		if (!nodeMetrics.decorations) {
			decorationsDOM.style.display = 'none';
		} else {
			decorationsDOM.style.display = '';
			decorationsDOM.style.position = 'absolute';
			decorationsDOM.style.top = px(nodeMetrics.decorations.y - nodeMetrics.bubble.y);
			decorationsDOM.style.left = px(nodeMetrics.decorations.x - nodeMetrics.bubble.x);
			applyStickers(decorationsDOM, nodeView.stickers || [], nodeMetrics.decorations);
			applyLinkUrl(decorationsDOM, nodeView.hyperlink);
			applyLabel(decorationsDOM, nodeView.label);
			applyNote(decorationsDOM, nodeView.note);
			applyAttachment(decorationsDOM, nodeView.attachment, nodeView.nodeId);
		}
	},
	updateNodeDecorations = (nodeView, nodeDOM) => {
		if (!nodeView) {
			throw new Error('invalid-args');
		}
		const nodeMetrics = nodeView.metrics,
			shouldBeShown = !!nodeMetrics.decorations,
			decorationsDOM = ensureElementIfNeeded(nodeDOM, 'div', '[data-mapjs-role=decorations]', shouldBeShown, {'data-mapjs-role': 'decorations', class: 'mapjs-decorations'});
		if (shouldBeShown) {
			updateDecorations(nodeView, decorationsDOM);
		}
		return decorationsDOM;
	};


module.exports = updateNodeDecorations;
